// Link to source (broofa): https://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid
// Template resolves to "10000000-1000-4000-8000-100000000000" in the original JS via array coercion.
const UUID_TEMPLATE = '10000000-1000-4000-8000-100000000000';

export function createGUID(): string {
    return UUID_TEMPLATE.replace(/[018]/g, (c: string) => {
        const n = parseInt(c, 10);
        return (n ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (n / 4)))).toString(16);
    });
}
